import { SHOW_SCHEDULE_EDIT_TIME, HIDE_SCHEDULE_EDIT_TIME } from './types'

const initialState = {
  scheduleEditTime: {
    show: false,
    position: {},
    data: {},
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_SCHEDULE_EDIT_TIME:
      return {
        ...state,
        scheduleEditTime: {
          show: true,
          position: action.position,
          data: action.data
        }
      };
    case HIDE_SCHEDULE_EDIT_TIME:
      return {
        ...state,
        scheduleEditTime: {
          show: false,
          position: {},
          data: {}
        }
      };
    default: return state;
  }
};

export default reducer;
